import React from 'react';
import $ from "jquery";

class FillGapQuestionOptions extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            selectedAnswer:'',
            selectedAdditionalAnswer:'',
        }

    }
    /*componentDidMount() {
        document.addEventListener("keydown", this.handleLastChange.bind(this));
    }*/
    /*componentDidUpdate() {


        //$("input.gap").last().css('border','1px solid red');
        $("input.gap").last().on('keyup',e=>{
            //this.props.setResult(e.target.value);
            console.log('hi last')
        })
       /!* $("input.gap").each(function(){
            console.log($(this))
        });*!/

    }*/
        /*
    componentWillReceiveProps(newProps) {
        console.log('in will recieve')
    }*/
    handleLastChange(e){
     /*   console.log(e)
        console.log(e.target)
        console.log(e.target.value)*/
        //console.log($(e.target));
       /* console.log($(e.target).last())*/

       /* $("input.gap").each(function(){
            console.log($(this))
            if($(this) == $(e.target) ){
                console.log('hi last')
            }
        });*/
        console.log($("input.gap").last().val())


      /* if($(e.target) == $("input.gap").last()){
           console.log('hi last')
       }else{
           console.log('not last change');
       }*/
       // console.log($("input.gap").last());

       /* if(e.target.last()){
            console.log('last change');
        }else{
            console.log('not last change');
        }*/

    }

    handleChangeText(e){
        /*console.log(e.target.value)*/
        this.setState({selectedAnswer: e.target.value});
        this.props.setResult(e.target.value)
        this.props.setAdditionalResult(this.state.selectedAdditionalAnswer)
    }
    render(){

        return(
            <input
                type='text'
                className='form-control gap'
                placeholder=''
               /* onBlur={this.handleChangeText.bind(this)}*/
                onKeyUp={this.handleChangeText.bind(this)}

            />
        );
    }
}
export default FillGapQuestionOptions;
